"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartRemoveButton = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const key_1 = require("../../utils/key");
class CartRemoveButton extends base_component_1.BaseComponent {
    mountComponent() {
        this.addListener(this, 'keydown', this.handleKeyDown);
        this.addListener(this, 'click', this.handleButtonClick);
    }
    handleButtonClick = (event) => {
        event.preventDefault();
        this.update();
    };
    handleKeyDown = (event) => {
        if ((0, key_1.isEnterKey)(event)) {
            event.preventDefault();
            this.update();
        }
    };
    update() {
        const cart = (0, utils_1.$elParent)('cart-page, cart-drawer', this);
        const index = this.dataset.index;
        if (cart && index) {
            cart.updateItem(+index, 0);
        }
    }
}
exports.CartRemoveButton = CartRemoveButton;
